
export default function About() {
  const stats = [
    { value: '500+', label: 'Houston Families Served' },
    { value: '50+', label: 'Insurance Carriers' },
    { value: '24/7', label: 'Always Available' },
    { value: '15+', label: 'Years Experience' },
  ];

  return (
    <section id="about" className="py-24 bg-navy-50/40">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative w-full h-[550px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/8b2d7d850b193b25bf37e6f508e42d00.jpg"
                alt="Health insurance consultation in Houston TX"
                title="Private health insurance consultation at Data Health Insurance Consultants Houston"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 bg-brand-500 text-white rounded-xl p-6 shadow-xl shadow-brand-500/20">
              <div className="text-3xl font-display font-bold">24/7</div>
              <div className="text-sm font-medium text-brand-100">Open for You</div>
            </div>
          </div>

          <div>
            <span className="inline-flex items-center gap-2 text-brand-600 text-sm font-semibold tracking-wider uppercase mb-3">
              <span className="w-8 h-[2px] bg-brand-500"></span>
              About Us
            </span>
            <h4 className="text-4xl font-display font-bold text-navy-900 mb-6 leading-tight">
              <a href="#about">Houston&apos;s Independent Private Health Insurance Broker</a>
            </h4>
            <p className="text-navy-600 text-base leading-relaxed mb-4">
              Located at <strong>1500 North Blvd Suite 5000-1006 in Houston, TX 77006</strong>, Data Health Insurance Consultants operates as an independent broker with one mission: simplifying private medical
              insurance for individuals and companies across the Houston area.
            </p>
            <p className="text-navy-500 text-sm leading-relaxed mb-8">
              We compare health insurance plans from over 50 carriers to find the best coverage at the best price. Whether you need individual health insurance,
              family coverage, or company group plans, our Houston consultants provide expert advice and market comparisons — available <strong>24 hours a day, 7
              days a week</strong> because your health coverage questions don&apos;t follow business hours.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-white rounded-xl p-5 border border-navy-100">
                  <div className="text-2xl font-display font-bold text-brand-600">{stat.value}</div>
                  <div className="text-navy-500 text-xs font-medium mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3">
              <a
                href="#contact"
                className="px-6 py-3 bg-brand-500 text-white text-sm font-semibold rounded-lg hover:bg-brand-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Schedule Free Consultation
              </a>
              <a
                href="tel:7138049039"
                className="px-6 py-3 border border-navy-200 text-navy-800 text-sm font-semibold rounded-lg hover:bg-navy-50 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-brand-500"></i>
                </div>
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
